module.exports = "/src/assets/images/contact-bg.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contact-bg.jpg
// module id = 23
// module chunks = 0